<template>
  <div class="ch-component-warpper">
    <div class="ch-component">
      <button
        class="ch-floating-btn ch-menu-btn"
        @click="openDialog"
      >
        <span><i class="far fa-plus-square fa-fw"></i></span>
        HOTEL
      </button>
      <v-container fluid grid-list-lg class="ch-menu-wrapper">
        <div class="ch-menu-title">
          <!-- <button
            @click.stop="toogleDrawer"
            class="ch-menu-btn ch-navigation-toogle mr-2"
            type="button"
          >
            <span class="ch-menu-btn-icon" v-show="navigationDrawer">
              <i class="fas fa-minus fa-fw"></i>
            </span>
            <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
              <i class="fas fa-plus fa-fw"></i>
            </span>
          </button> -->
          <span class="ch-component-title">HOTEL</span>
        </div>
        <div class="filter-body-wrapper">
          <hotels-filter :storeFilter="storeFilter"></hotels-filter>
        </div>
      </v-container>
      <v-container fluid grid-list-lg class="pt-4">
        <hotels-list :storeFilter="storeFilter" :storePage="storePage"></hotels-list>
      </v-container>
      <create-hotel></create-hotel>
      <scroll-event></scroll-event>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import { hotelsEventBus } from '@/components/admin/hotels/hotelsEventBus';
  import HotelsFilter from '@/components/admin/hotels/HotelsFilter';
  import HotelsList from '@/components/admin/hotels/HotelsList';
  import CreateHotel from '@/components/admin/hotels/CreateHotel';
  import ScrollEvent from '@/components/customized-components/ScrollEvent';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        navigationDrawer: true,
      };
    },
    methods: {
      // NOTE: clear form
      clearForm() {
        this.dialog = false;
        hotelsEventBus.$emit('clearForm');
      },
      // NOTE: toogle navigation drawer
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
      openDialog() {
        hotelsEventBus.$emit('openDialog');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      HotelsFilter, HotelsList, CreateHotel, ScrollEvent,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Hotels.vue